import { useTranslation } from 'react-i18next'

import { PaymentVerification } from '@widgets/payment-verification'

import SEO from '@shared/components/SEO'
import { BRAND_NAME } from '@shared/contants/app'

export default function PaymentVerificationPage () {
  const { t } = useTranslation('seo')
  return (
    <>
      <SEO
        title={t('payment_verification.title', { brand: BRAND_NAME })}
        description={t('payment_verification.description', { brand: BRAND_NAME })}
      />
      <PaymentVerification />
    </>
  )
}
